module.exports = __webpack_public_path__ + "fonts/Livory.woff2";